/**
 * @overview 问卷模版设计
 * @author jzhu
 * @date 2020-3-31
 */
import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import { framework_tool, component_tool } from '../../../../tool'
import { WizQuestionnair } from '../../../../module'
let { WizContainer } = framework_tool
let { WizRow, WizCol, WizButton } = component_tool
import './index.less'

class SurveyTemplateQuestionDetail extends WizContainer {

  componentName = 'SurveyTemplateQuestionDetail'

  constructor(props) {
    super(props)
    this.state = {
      surveyTemplateId: props.surveyTemplateId,
      type: props.type,
      status: 0
    }
  }

  _componentDidMount() {
    this.doAction({
      path: 'surveyTemplate/getSurveyTemplateInfo',
      payload: {
        key: 'surveyTemplateInfo_' + this.state.surveyTemplateId,
        apiParams: { id: this.state.surveyTemplateId }
      }
    })
  }

  _createQuestions(values) {
    this.doAction({
      path: 'surveyTemplate/createTemplateQuestions',
      payload: {
        key: 'createTemplateQuestions_' + this.state.surveyTemplateId,
        apiParams: { surveyTemplateId: this.state.surveyTemplateId, questions: values }
      }
    })
  }

  _updateQuestions(values) {
    this.doAction({
      path: 'surveyTemplate/updateTemplateQuestions',
      payload: {
        key: 'updateTemplateQuestions_' + this.state.surveyTemplateId,
        apiParams: { surveyTemplateId: this.state.surveyTemplateId, questions: values }
      }
    })
  }

  _saveAndNext = () => {
    this.setState({ status: 1 }, () => {
      let values = this._fitterValues()
      if (this.state.type === 'update') {
        this._updateQuestions(values)
      } else {
        this._createQuestions(values)
      }
    })
  }

  _saveAndBack = () => {
    this.setState({ status: 2 }, () => {
      let values = this._fitterValues()
      if (this.state.type === 'update') {
        this._updateQuestions(values)
      } else {
        this._createQuestions(values)
      }
    })
  }

  _onReset = () => {
    this.setState({ resetTime: new Date().getTime() })
  }

  _fitterValues() {
    return this._surveyTemplate && this._surveyTemplate._fitterValues()
  }

  propsAndStateOnChange = {
    createQuestions: this._createQuestionsOnChange.bind(this),
    updateQuestions: this._updateQuestionsOnChange.bind(this)
  }

  _createQuestionsOnChange(nextProps, nextState) {
    if (nextProps.createQuestions.code === 1) {
      if (this.state.status === 1) {
        this.props.nextFunc && this.props.nextFunc()
      } else if (this.state.status === 2) {
        this.props.backFunc && this.props.backFunc()
      }
    }
    return true
  }

  _updateQuestionsOnChange(nextProps, nextState) {
    if (nextProps.updateQuestions.code === 1) {
      if (this.state.status === 1) {
        this.props.nextFunc && this.props.nextFunc()
      } else if (this.state.status === 2) {
        this.props.backFunc && this.props.backFunc()
      }
    }
    return true
  }

  _prev = () => {
    this.props.prevFunc && this.props.prevFunc()
  }

  _render() {
    const tabs = [{ name: '基本题型', type: 'question' }]
    const classNames = {
      siderbarClass: 'survey-siderbar',
      pageClass: 'survey-page'
    }
    let questionnairProps = {
      key: this.props.surveyTemplateInfo && this.props.surveyTemplateInfo.data && this.props.surveyTemplateInfo.data.id + this.state.resetTime,
      editors: this.props.surveyTemplateInfo && this.props.surveyTemplateInfo.data && this.props.surveyTemplateInfo.data.questions,
      ref: surveyTemplate => this._surveyTemplate = surveyTemplate,
      ...classNames,
      tabs,
      renderTitle: () => this._renderTitle('问卷标题', '问卷说明'),
      renderTabs: () => this._renderTabs(tabs)
    }
    return (
      <>
        <WizQuestionnair {...questionnairProps} />
        <WizRow className='survey-button-row'>
          <WizCol>
            <WizButton title='上一步' onClick={this._prev}>上一步</WizButton>
            <WizButton title='保存并返回' type='primary' onClick={this._saveAndBack}>保存并返回</WizButton>
            <WizButton title='重置' type='reset' onClick={this._onReset}>重置</WizButton>
          </WizCol>
        </WizRow>
      </>
    )
  }

  _renderTabs(tabs) {
    return (
      <div className='survey-tabs'>
        {
          tabs.map((data, index) => {
            return (
              <div key={data.type} className='survey-active-tab'>
                {data.name}
              </div>
            )
          })
        }
      </div>
    )
  }

  _renderTitle(title, intro) {
    return (
      <div className='survey-title'>
        {title}
        <div className='survey-intro'>
          {intro}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { surveyTemplate } = state
  let { surveyTemplateId } = ownProps
  const surveyTemplateInfo = modelUtils.getModelEntity(surveyTemplate, 'surveyTemplateInfo_' + surveyTemplateId)
  const createQuestions = modelUtils.getModelEntity(surveyTemplate, 'createTemplateQuestions_' + surveyTemplateId)
  const updateQuestions = modelUtils.getModelEntity(surveyTemplate, 'updateTemplateQuestions_' + surveyTemplateId)
  return {
    surveyTemplateInfo,
    createQuestions,
    updateQuestions
  }
}

export default connect(mapStateToProps)(SurveyTemplateQuestionDetail)
